import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";
import "./PostListing.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import Modal from "react-bootstrap/Modal";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import ReactPaginate from "react-paginate";

const PostListing = () => {
  // State for posts and pagination
  const [imagePosts, setImagePosts] = useState([]);
  const [videoPosts, setVideoPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination state
  const [imagePage, setImagePage] = useState(1);
  const [imageTotalPages, setImageTotalPages] = useState(1);
  const [videoPage, setVideoPage] = useState(1);
  const [videoTotalPages, setVideoTotalPages] = useState(1);

  const [show, setShow] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));

  const handleClose = () => {
    setShow(false);
    setSelectedPost(null);
  };

  const handleShow = (post) => {
    setSelectedPost(post);
    setShow(true);
  };

  // Fetch posts with pagination params
  const fetchImagePosts = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get(
        `/posts/filter/images?page=${page}&limit=10`
      );
      setImagePosts(response.data.posts);
      setImageTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Error fetching image posts:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchVideoPosts = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get(
        `/posts/filter/videos?page=${page}&limit=10`
      );
      setVideoPosts(response.data.posts);
      setVideoTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Error fetching video posts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchImagePosts(imagePage);
  }, [imagePage]);

  useEffect(() => {
    fetchVideoPosts(videoPage);
  }, [videoPage]);
  useEffect(() => {
    if (loading) {
      // Scroll window to top when loading starts
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [loading]);

  const handleImagePageClick = (data) => {
    setImagePage(data.selected + 1);
  };

  const handleVideoPageClick = (data) => {
    setVideoPage(data.selected + 1);
  };

  // Loader component JSX for loading state
  if (loading) {
    return (
      <div className="main">
        <div className="up">
          <div className="loaders">
            {[...Array(10)].map((_, i) => (
              <div key={i} className="loader"></div>
            ))}
          </div>
          <div className="loadersB">
            {[...Array(9)].map((_, i) => (
              <div key={i} className="loaderA">
                <div className={`ball${i}`}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="post-listing">
        <div className="post-overlayer">
          <Tabs>
            <TabList>
              <Tab>Quotes</Tab>
              <Tab>Video</Tab>
            </TabList>

            {/* Quotes Tab */}
            <TabPanel>
              <div className="container mt-5">
                {imagePosts.length === 0 ? (
                  <div className="spiritual-message-container">
                    <p className="spiritual-message">
                      In the silence of the moment, sometimes no words are
                      needed. The universe will soon share its wisdom here.
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="pinterest-grid">
                      {imagePosts.map((post) => (
                        <div
                          key={post._id}
                          className="post-card"
                          onClick={() => handleShow(post)}
                        >
                          <div className="post-image-img ">
                            <div className="edit">
                              <Link
                                to={
                                  new URL(
                                    `/edit-post/${post._id}`,
                                    window.location.origin
                                  ).pathname
                                }
                                className="edit-button"
                              >
                                <HiOutlinePencilSquare
                                  color="rgb(82 50 8 / 91%)"
                                  size={18}
                                />
                              </Link>
                            </div>

                            <img src={post.url} alt="Post media" />
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Pagination Controls */}
                    <ReactPaginate
                      previousLabel={"←"}
                      nextLabel={"→"}
                      pageCount={imageTotalPages}
                      onPageChange={handleImagePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      previousClassName={"previous"}
                      nextClassName={"next"}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      forcePage={imagePage - 1} // <--- Add this line here
                    />
                  </>
                )}
              </div>
            </TabPanel>

            {/* Video Tab */}
            <TabPanel>
              <div className="container mt-5">
                {videoPosts.length === 0 ? (
                  <div className="spiritual-message-container">
                    <p className="spiritual-message">
                      The flow of life pauses for now, but soon, stories will
                      rise like waves to inspire your soul.
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="row d-flex align-items-center justify-content-center">
                      {videoPosts.map((post) => (
                        <div key={post._id} className="col-md-6 col-lg-3">
                          <div className="post-video post-card">
                            <div
                              className="video-overlayer"
                              onClick={() => handleShow(post)}
                            ></div>
                            <div className="vid-section">
                              {user?.role === "admin" && (
                                <div className="edit">
                                  <Link
                                    to={`/edit-post/${post._id}`}
                                    className="edit-button"
                                  >
                                    <HiOutlinePencilSquare
                                      color="rgb(82 50 8 / 91%)"
                                      size={18}
                                    />
                                  </Link>
                                </div>
                              )}
                              <iframe
                                src={post.url}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="Post Video"
                                className="post-video-iframe"
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Pagination Controls */}
                    <ReactPaginate
                      previousLabel={"←"}
                      nextLabel={"→"}
                      pageCount={videoTotalPages}
                      onPageChange={handleVideoPageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      previousClassName={"previous"}
                      nextClassName={"next"}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      forcePage={videoPage - 1} // <--- And this here
                    />
                  </>
                )}
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>

      {/* Modal for Post Preview */}
      <Modal
        size="lg"
        className="img-model"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body>
          {selectedPost && (
            <>
              <div className="model-img">
                {selectedPost.type === "image" ? (
                  <img src={selectedPost.url} alt="Post media" />
                ) : (
                  <div className="post-video-iframe-model embed-responsive embed-responsive-16by9">
                    <iframe
                      className="post-video-iframe"
                      src={selectedPost.url}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Post Video"
                    />
                  </div>
                )}
              </div>
              <h6>Description:</h6>
              <p className="post-caption">{selectedPost.caption}</p>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PostListing;
